import React, { createContext, useReducer } from 'react';
import { useMemoOne } from 'use-memo-one';
import { NSTable } from '../../types/interfaces/NSTable';
import { tableStateReducer } from './TableStateReducer';

const TableStateValues = {
  state: {},
  setPage: () => null,
  initTableState: () => null,
  setSorting: () => null,
  setFiltering: () => null,
  setPopup: () => null,
  setCheckedRow: () => null,
  setAllRowsIsChecked: () => null,
};

export const TableStateContext = createContext<any>(TableStateValues);

export const TableStateProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer<NSTable.TReducer>(tableStateReducer.reducer, {});

  const initTableState = useMemoOne(
    () => (tableName: string) => dispatch(tableStateReducer.actions.initState(tableName)),
    [],
  );

  const setPage = useMemoOne(
    () => (tableName: string, page: number) => dispatch(tableStateReducer.actions.setPage(tableName, page)),
    [],
  );

  const setSorting = useMemoOne(
    () => (tableName: string, sorting: NSTable.ISortingArgument) =>
      dispatch(tableStateReducer.actions.setSorting(tableName, sorting)),
    [],
  );

  const setFiltering = useMemoOne(
    () => (tableName: string, filtering: NSTable.IFilteringArgument[]) =>
      dispatch(tableStateReducer.actions.setFiltering(tableName, filtering)),
    [],
  );

  const setPopup = useMemoOne(
    () => (tableName: string, name: string, popup: NSTable.IPopupArgument) =>
      dispatch(tableStateReducer.actions.setPopup(tableName, name, popup)),
    [],
  );

  const setCheckedRow = useMemoOne(
    () => (tableName: string, checkedId: string) =>
      dispatch(tableStateReducer.actions.setCheckedRow(tableName, checkedId)),
    [],
  );

  const setAllRowsIsChecked = useMemoOne(
    () => (tableName: string, idList: string[]) =>
      dispatch(tableStateReducer.actions.setAllRowsIsChecked(tableName, idList)),
    [],
  );

  return (
    <TableStateContext.Provider
      value={{
        state,
        setPage,
        initTableState,
        setSorting,
        setFiltering,
        setPopup,
        setCheckedRow,
        setAllRowsIsChecked,
      }}
    >
      {children}
    </TableStateContext.Provider>
  );
};
